'use client';

import { Toaster as SonnerToaster } from 'sonner';
import { useIsMobile } from '@/hooks/useIsMobile';
import { SONNER_TOAST_ICONS } from '@/components/shared/toast/ToastIcon';
import '@/components/shared/toast/toast.css';

/**
 * Sonner toasts stack bottom-right on desktop, as Linear's do. On mobile they sit
 * bottom-center, clear of the fixed MobileHeader (72px + safe area).
 *
 * No `richColors`: that filled an error toast solid red. The card stays white and
 * the status shows only in the icon (components/shared/toast/toast.css).
 */
export function ResponsiveSonnerToaster() {
  const isMobile = useIsMobile();

  return (
    <SonnerToaster
      className="mb-toast"
      position={isMobile ? 'bottom-center' : 'bottom-right'}
      icons={SONNER_TOAST_ICONS}
      closeButton
      offset={16}
      mobileOffset={{
        bottom: 'max(16px, env(safe-area-inset-bottom))',
      }}
    />
  );
}
